import React from "react";

const Checkbox = ({
  label,
  name,
  checked,
  onChange,
  variant = "default",
  icon,
  disabled = false,
  onDisabledClick,
}) => {
  // ================= DEFAULT (NO CHANGE) =================
  if (variant === "default") {
    return (
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          className="w-4 h-4 accent-orange-600"
        />
        <span className="text-sm text-gray-700">{label}</span>
      </label>
    );
  }
  // ================= PILL STYLE (like Lunch/Dinner toggle) =================
  if (variant === "pill") {
    return (
      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          if (disabled) return; // 🚫 block click
          const fakeEvent = { target: { checked: !checked } };
          onChange(fakeEvent);
        }}
        className={`
          flex items-center gap-2 px-4 py-2 rounded-xl border transition
          ${
            disabled
              ? "bg-gray-100 text-gray-400 border-gray-300 "
              : checked
                ? "bg-[#FF6943] text-white border-orange-500 cursor-pointer"
                : "bg-white text-gray-700 border-gray-300 hover:border-orange-400 cursor-pointer"
          }
        `}
      >
        {icon && <span className="flex items-center">{icon}</span>}
        <span className="text-sm font-medium">{label}</span>
      </button>
    );
  }
  if (variant === "radio") {
    return (
      <button
        type="button"
        onClick={() => {
          if (disabled) {
            onDisabledClick?.();
            return;
          }
          if (checked) return;
          onChange({ target: { name, value: name, checked: true } });
        }}
        className={`
    flex items-center gap-2 px-4 py-2 rounded-xl border transition
    ${
      disabled
        ? "bg-gray-100 text-gray-400 border-gray-300 "
        : checked
          ? "bg-[#FF6943] text-white border-orange-500"
          : "bg-white text-gray-700 border-gray-300 hover:border-orange-400"
    }
  `}
      >
        {icon && <span>{icon}</span>}
        <span className="text-sm font-medium">{label}</span>
      </button>
    );
  }

  return null;
};

export default Checkbox;
